function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 24C0 37.2548 10.7452 48 24 48V0C10.7452 0 0 10.7452 0 24Z",
  fill: "url(#paint0_linear_feat)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M48 24C48 10.7452 37.2548 0 24 0V48C37.2548 48 48 37.2548 48 24Z",
  fill: "url(#paint1_linear_feat)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_feat",
  x1: 12,
  y1: 9.72245e-8,
  x2: 7.80189,
  y2: 47.63,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BBF5EF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6DEEE0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_feat",
  x1: 24,
  y1: 48,
  x2: 24,
  y2: -0.00000286102,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#61FFF0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EBFCAA"
})));

var SvgFeature1 = function SvgFeature1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFeature1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/feature-1.dc6afaea.svg";
export { ForwardRef as ReactComponent };